<div class="drawer-navigation" #drawerNavigation
  [ngClass]="{'isOpen':isActive,'desktop':mediaSizeIsDesktop, 'isHome': isHome}">

  <app-panel-navigation></app-panel-navigation>
</div>
<div *ngIf="isActive && mediaSizeIsDesktop" class="dismiss-overlay" (click)="onCloseDrawerNavigation()"></div>
